import { company } from '~/company/Company';

import { CloudflareResizeOptions } from './CloudflareResizeOptions';

const fitToResizeType: Record<string, string> = {
  'scale-down': 'fit',
  contain: 'fit',
  cover: 'fill',
  crop: 'fill',
  pad: 'fit',
  auto: 'auto',
};

export const removeSlash = (src: string) =>
  src.startsWith('/') ? src.slice(1) : src;

const getImgproxyUrl = (
  src: string,
  domain: string,
  options: CloudflareResizeOptions,
): string => {
  const processingOptions: string[] = [];

  const resizeType = options.fit
    ? (fitToResizeType[options.fit] ?? 'fit')
    : 'fit';
  const width = options.width ?? 0;
  const height = options.height ?? 0;
  processingOptions.push(`rs:${resizeType}:${width}:${height}`);

  if (options.dpr) {
    processingOptions.push(`dpr:${options.dpr}`);
  }

  if (options.quality) {
    processingOptions.push(`q:${options.quality}`);
  }

  if (options.blur) {
    processingOptions.push(`bl:${options.blur}`);
  }

  if (options.sharpen) {
    processingOptions.push(`sh:${options.sharpen}`);
  }

  if (options.gravity) {
    processingOptions.push(`g:${options.gravity}`);
  }

  if (options.rotate) {
    processingOptions.push(`rot:${options.rotate}`);
  }

  if (options.brightness) {
    processingOptions.push(`br:${options.brightness}`);
  }

  if (options.contrast) {
    processingOptions.push(`co:${options.contrast}`);
  }

  if (options.background) {
    processingOptions.push(`bg:${options.background}`);
  }

  return `${domain}/insecure/${processingOptions.join('/')}/plain/${removeSlash(src)}`;
};

const getCloudflareImageUrl = (
  src: string,
  domain: string,
  options: CloudflareResizeOptions,
): string => {
  const params = Object.entries(options).map(
    ([key, value]) => `${key}=${value}`,
  );

  params.push('format=auto');

  return `${domain}/cdn-cgi/image/${params.join(',')}/${removeSlash(src)}`;
};

export const getCloudflareUrl = (
  src: string,
  domain?: string,
  options?: CloudflareResizeOptions,
): string => {
  if (!options) {
    return src;
  }

  const buildUrl = company.match({
    citydrinks: getCloudflareImageUrl,
    default: getImgproxyUrl,
  });

  return buildUrl(src, domain ?? '', options);
};
